import type { FaireProductEntity } from "../../entity_types/product";

export const p_umem7duubv: FaireProductEntity = {
  token: "p_umem7duubv",
  type: "product",
  name: "Bookmark Set, Sandwich",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/b9a1678850f3d1ae3f3f967b56467d1e520ad3f19fcfeb8fe01784b660eb9348.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f19456f9c1bdcd550d245fd61ed5892d873e112329f1b5ff7994f5839b19b17c.jpeg",
    "https://cdn.faire.com/fastly/a0562c4952963cb5c39afd8371db67222db2d1c783c03266d7200e09d20d8da6.jpeg",
    "https://cdn.faire.com/fastly/c0939940f220993a2638069a64ec0326030ab4a75086089e93877e630283570c.jpeg",
    "https://cdn.faire.com/fastly/608e58dafd00acce963d88213654b263bc38935574298fbd5c0f9696dd7e8634.jpeg",
    "https://cdn.faire.com/fastly/ee2a691d46b39a876449edc31ec50a4d3fb542c7018adc4b1b3eb4b40062a79e.jpeg",
    "https://cdn.faire.com/fastly/9ccaa52c82a57b6f76eec99d86b9c6f3adb5e850f4f6c2d304c0a4f3f96269b5.jpeg",
    "https://cdn.faire.com/fastly/37d32a5b88dd839f0559fb37c33e55dc40ec086157c14dadfe0637ead1b330f1.jpeg",
    "https://cdn.faire.com/fastly/20cca5897abe6bc61935b45874d02c70ee413efdc4564ac44dac3daf89430ed4.jpeg",
    "https://cdn.faire.com/fastly/fc426fce192ae430e8b787b40220ca734f65a22b191589d94fa41535fdac7e35.jpeg"
  ],
  priceDollars: 5,
  description: "A delicious set of bookmarks to really dig into. This set of six bookmarks features each component of the perfect sub sandwich, stacked with personality and ready to save your spot. Cute, clever, and guaranteed to make your reading time feel extra tasty.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• Set of 6 food-themed bookmarks inspired by sub sandwich layers\n• Slim, durable designs perfect for books, planners, journals, and notebooks\n• Bright, playful artwork for maximum joy\n• Lightweight and great for gifting\n• Designed in Bando’s signature colorful, whimsical style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫\n\n• Gift shops and bookstores\n• Stationery and lifestyle retailers\n• Students, readers, and food-themed accessory lovers\n• Wholesale buyers seeking fun, eye-catching novelty stationery",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:41.169Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
